let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lgHXt")).then(() => parcelRequire('hK9Ia'));